import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";

let registrationPopHandler = null;
window.addEventListener("popstate", (event) => registrationPopHandler?.(event));

export const RegistrationLeaveGuard = ({ dirty, children }) => {
  const location = useLocation(), navigate = useNavigate();
  const [pending, setPending] = useState(null);
  const bypass = useRef(false);

  useEffect(() => {
    bypass.current = false;
    if (!dirty) { setPending(null); return; }
    const currentIndex = window.history.state?.idx;
    let restoring = null;
    const onPop = (event) => {
      if (bypass.current) return;
      const nextIndex = event.state?.idx;
      if (!Number.isInteger(currentIndex) || !Number.isInteger(nextIndex)) return;
      event.stopImmediatePropagation();
      if (nextIndex === currentIndex) {
        if (restoring !== null) { setPending({ delta: restoring }); restoring = null; }
        return;
      }
      const delta = nextIndex - currentIndex;
      if (restoring === null) restoring = delta;
      window.history.go(-delta);
    };
    const onUnload = (event) => {
      if (bypass.current) return;
      event.preventDefault();
      event.returnValue = "";
    };
    registrationPopHandler = onPop;
    window.addEventListener("beforeunload", onUnload);
    return () => {
      registrationPopHandler = null;
      window.removeEventListener("beforeunload", onUnload);
    };
  }, [dirty, location.key]);

  const interceptLink = (event) => {
    if (!dirty || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest("a[href]");
    if (!anchor || anchor.hasAttribute("download") || anchor.target && anchor.target !== "_self") return;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname === location.pathname && url.search === location.search) return;
    event.preventDefault();
    event.stopPropagation();
    setPending({ to: `${url.pathname}${url.search}${url.hash}` });
  };
  const leave = () => {
    if (!pending) return;
    bypass.current = true;
    setPending(null);
    navigate(pending.to ?? pending.delta);
  };

  return <>
    <div className="contents" onClickCapture={interceptLink}>{children}</div>
    <AlertDialog open={!!pending} onOpenChange={(open) => { if (!open) setPending(null); }}>
      <AlertDialogContent data-testid="registration-leave-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="registration-leave-title">Vuoi lasciare la pagina?</AlertDialogTitle>
          <AlertDialogDescription data-testid="registration-leave-description">Attenzione, lasciando questa pagina potresti perdere i dati</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="border-primary bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground" onClick={() => setPending(null)} data-testid="registration-leave-stay">Resta sulla pagina</AlertDialogCancel>
          <AlertDialogAction className="border border-input bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground" onClick={leave} data-testid="registration-leave-confirm">Lascia la pagina</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </>;
};
